import "./css/Landing.css";
import { Routes, Route, Navigate } from "react-router-dom";

// COMPONENTS
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Home";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";

function Landing() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="welcome" element={<Home />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="*" element={<Navigate to="not-found" />} />
      </Routes>
      <Footer />
    </>
  );
}

export default Landing;
